// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("wedobooks" + "." + "9e0d8bb4f40eb4afdc57" + ".js");